import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { SNACKBAR_FACADE } from '@dges/modules/snackbar';

import * as JobsActions from './jobs.actions';
import { from, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import {
  Job,
  JobWithTimestamp,
  JOBS_COLLECTION,
} from '@dges/modules/portfolio/domain';
import { Timestamp } from '@angular/fire/firestore';

@Injectable()
export class JobsEffects {
  private actions$ = inject(Actions);
  private angularFire = inject(JOBS_COLLECTION);
  private snackBar = inject(SNACKBAR_FACADE);

  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(JobsActions.loadJobs),
      switchMap(() => {
        return this.angularFire.getJobs().pipe(
          map((jobs: JobWithTimestamp[]) =>
            jobs.map((job: JobWithTimestamp) => {
              return {
                ...job,
                endDate: job.endDate
                  ? (job.endDate as unknown as Timestamp).toDate()
                  : null,
                startDate: job.startDate
                  ? (job.startDate as unknown as Timestamp).toDate()
                  : null,
              };
            }),
          ),
          map((jobs: Job[]) => JobsActions.loadJobsSuccess({ jobs: jobs })),
          catchError((error) => of(JobsActions.loadJobsFailure(error))),
        );
      }),
    ),
  );

  public addJobs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(JobsActions.addJob),
      switchMap((actionProps) => {
        return from(this.angularFire.addJob(actionProps.job)).pipe(
          map(() => {
            return JobsActions.addJobSuccess();
          }),
          catchError((error) => {
            this.snackBar.queueSnackBar(error.message);
            return of(JobsActions.addJobFailure(error));
          }),
        );
      }),
    ),
  );

  public deleteJobs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(JobsActions.deleteJob),
      switchMap((actionProps) =>
        from(this.angularFire.deleteJob(actionProps.job)).pipe(
          map(() => {
            return JobsActions.deleteJobSuccess();
          }),
          catchError((error) => {
            this.snackBar.queueSnackBar(error.message);
            return of(JobsActions.deleteJobFailure(error));
          }),
        ),
      ),
    ),
  );

  public editJobs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(JobsActions.editJob),
      switchMap((actionProps) =>
        from(this.angularFire.editJob(actionProps.job)).pipe(
          map(() => {
            return JobsActions.editJobSuccess();
          }),
          catchError((error) => {
            this.snackBar.queueSnackBar(error.message);
            return of(JobsActions.editJobFailure(error));
          }),
        ),
      ),
    ),
  );
}
